import { render, staticRenderFns } from "./SrEditableList.vue?vue&type=template&id=05be5870"
import script from "./SrEditableList.vue?vue&type=script&lang=js"
export * from "./SrEditableList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports